import React, { Fragment, useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { ModalService } from 'common/Services/ModalService'
import { GTM_CONTENTSQUARE_TRIGGER } from 'utils/tracking'
import { safeLogTrackedEvent } from 'common/Hocs/withCSTracker'

const el = document.getElementById('root')

const ModalHandler = (props) => {
    const [modals, setModals] = useState([])
    const trackedModalsRef = useRef(new Set())

    const csTracking = (modalName = '', open = true) => {
        // Prevent duplicate tracking
        if (open) {
            if (trackedModalsRef.current.has(modalName)) {
                return
            }
            trackedModalsRef.current.add(modalName)
        } else {
            if (!trackedModalsRef.current.has(modalName)) {
                return
            }
            trackedModalsRef.current.delete(modalName)
        }

        const csId = modalName
        const category = 'modal'
        const eventData = {
            name: csId,
            category,
        }

        window.dataLayer.push({
            event: GTM_CONTENTSQUARE_TRIGGER,
            cs_id: csId,
            cs_category: category,
            cs_content: open ? 'open' : 'close',
        })

        safeLogTrackedEvent(eventData)
    }

    useEffect(() => {
        const subscription = ModalService.getModal().subscribe((res) => {
            if (res && res.visible) {
                const newModal = props.modalsMap.find(
                    (modal) => modal.name === res.modalName
                )
                if (!newModal) return

                newModal.modalData = res.modalData
                newModal.outsideClose = res.outsideClose

                const closeModalsBefore = newModal.modalData.closeBefore
                if (closeModalsBefore) {
                    closeModalsBefore.forEach((modalName) => {
                        csTracking(modalName, false)
                    })
                }

                csTracking(newModal.name, true)

                setModals((prevModals) => {
                    const modalsName = prevModals.map((el) => el.name)

                    if (closeModalsBefore) {
                        const leftModals = prevModals.filter(
                            (modal) => !closeModalsBefore.includes(modal.name)
                        )
                        return [...leftModals, newModal]
                    } else {
                        if (modalsName.indexOf(newModal.name) >= 0) {
                            return [...prevModals]
                        }
                        return [...prevModals, newModal]
                    }
                })
            } else if (res && !res.visible) {
                if (res.hideAll) {
                    setModals((prevModals) => {
                        prevModals.forEach((modal) => {
                            csTracking(modal.name, false)
                        })
                        return []
                    })
                } else {
                    csTracking(res.modalName, false)
                    setModals((prevModals) => {
                        return prevModals.filter(
                            (modal) => modal.name !== res.modalName
                        )
                    })
                }
            }
        })
        return () => {
            subscription.unsubscribe()
        }
    }, [])

    useEffect(
        () => {
            props.isModalVisible(!!modals.length)
        },
        [modals]
    )

    const showModal = () => {}

    const hideModal = (name) => {
        ModalService.closeModal(name)
    }

    return ReactDOM.createPortal(
        <Fragment>
            {modals.map((modal, index) => {
                return props.children({
                    modal: modal.component,
                    data: modal.modalData,
                    type: modal.type,
                    modalName: modal.name,
                    key: index,
                    priority: index,
                    outsideClose: modal.outsideClose,
                    actions: {
                        showModal,
                        hideModal,
                    },
                })
            })}
        </Fragment>,
        el
    )
}

export default ModalHandler
